<div id="customMasonry">
  <div class="grid lg:grid-cols-4 grid-cols-1 gap-4">
    <div  *ngFor="let colItem of [].constructor(columnCount) ;let colIndex = index">
      <ng-container *ngFor="let item of data; let dataItemIndex = index">
        <ng-container *ngIf="dataItemIndex % columnCount === colIndex">
          <iho-masonry-item [reviewsCount]="reviewsCount" [data]="item" [isTruncate]="true"></iho-masonry-item>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
